/**
 * 判断值是否为字符串
 * @return 是否为字符串
 */
function isString(value) {
    return typeof value === 'string';
}

export { isString as default };
//# sourceMappingURL=is-string.js.map
